"use strict";

exports.__esModule = true;
exports.assign = assign;
exports.endsWith = endsWith;
exports.find = find;
exports.startsWith = startsWith;
function find(array, predicate) {
  for (var i = 0; i < array.length; i += 1) {
    var item = array[i];
    if (predicate(item, i)) {
      return item;
    }
  }
  return undefined;
}
function startsWith(candidate, search) {
  return candidate.slice(0, search.length) === search;
}
function endsWith(candidate, search) {
  return candidate.slice(-search.length) === search;
}
function assign(target) {
  for (var _len = arguments.length, toAssign = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    toAssign[_key - 1] = arguments[_key];
  }
  toAssign.forEach(function (source) {
    for (var _key2 in source) {
      if (Object.prototype.hasOwnProperty.call(source, _key2)) {
        target[_key2] = source[_key2];
      }
    }
  });
  return target;
}